import { render, staticRenderFns } from "./medical-history.vue?vue&type=template&id=03ea21d2&scoped=true&"
import script from "./medical-history.vue?vue&type=script&lang=js&"
export * from "./medical-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ea21d2",
  null
  
)

export default component.exports